import _ from 'lodash';
import * as actions from '../actions/product';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_REVIEWS_PAGE: {
      return Object.assign({}, state, {
        yotpoReviewsPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_GLOWFORGE_PRODUCTS_PAGE: {
      return Object.assign({}, state, {
        glowforgeProductsPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_CUSTOMER_GALLERY_PAGE: {
      const sections = _.get(action, 'result.fields.sections');
      const header = _.find(sections, { fields: { id: 'customer-gallery-header' } });
      const discoverHeader = _.find(sections, { fields: { id: 'customer-gallery-discover-header' } });
      const ctaButton = _.find(sections, { fields: { id: 'customer-gallery-cta' } });
      const strings = _.get(action, 'result.fields.unorderedShortText');
      const cards = _.filter(sections, { sys: { contentType: { sys: { id: 'textAndImageSection' } } } });
      return Object.assign({}, state, {
        customerGalleryPage: {
          titleText: _.get(header, 'fields.title'),
          subTitleText: _.get(header, 'fields.text'),
          titleTextDiscover: _.get(discoverHeader, 'fields.title'),
          subTitleTextDiscover: _.get(discoverHeader, 'fields.text'),
          lightboxCTA: _.get(_.find(strings, { fields: { id: 'lightbox-cta' } }), 'fields.text'),
          uploadText: _.get(_.find(strings, { fields: { id: 'user-photo-upload-text' } }), 'fields.text'),
          customerGalleryCTA: _.get(ctaButton, 'fields'),
          discoverCards: cards,
        },
      });
    }
    case actions.SET_MANUAL_PAGE: {
      return Object.assign({}, state, {
        manualPage: _.get(action, 'result.fields'),
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/product.js